<template>
  <div class="uk-container uk-flex uk-flex-center">
    <div class="uk-card uk-card-default card-availability">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">Availability</h3>
      </div>
      <div class="uk-card-body uk-padding-remove">
        <timetable :data="availability" type="view" />
      </div>
      <div class="uk-card-footer uk-text-center">
        <router-link
          class="uk-button uk-button-primary"
          :to="{ name: 'dentist-availability-update' }"
          uk-tooltip="title: Update your availability"
          data-cy="dav-update-btn"
        >
          Update Availability
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Timetable from '@/components/Timetable.vue'

export default {
  name: 'ViewDentistAvailabilityView',

  components: {
    Timetable
  },

  computed: {
    availability() {
      return this.$store.getters['dentists/availability']()
    }
  }
}
</script>

<style lang="scss" scoped>
 .card-availability {
    width: 100%;
    max-width: 600px;
 }
</style>
